<img class="slot" [class.visible]="showA" [src]="imgA" alt="">
<img class="slot" [class.visible]="!showA" [src]="imgB" alt="">
<div class="overlay">
    <img src="assets/img/home-v2/Extreme-Jobs-gradient-overlay-mobile.png" alt="">
</div>
